import { ComparatorStep } from '@kizi/comparator-core';

const summary: ComparatorStep = {
  path: 'summary',
  name: 'summary',
  fields: [
    {
      name: 'priceInfoIsUpdating',
    },
    {
      name: 'withDentalInsurance',
      value: 'false',
    },
  ],
};

export default summary;
